import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './shared/guards/noAuth.guard';
import { LayoutComponent } from './layouts/layout/layout.component';
import { LayoutClientComponent } from './layouts/layout-client/layout-client.component';
import { RoleGuard } from './shared/guards/role.guard';
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '',
  },

  {
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    path: 'forget-password',
    loadComponent: () =>
      import('./pages/auth/forget-password/forget-password.component').then(
        (m) => m.ForgetPasswordComponent,
      ),
  },
  {
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    path: 'activate/:token',
    loadComponent: () =>
      import('./pages/auth/activation/activation.component').then((m) => m.ActivationComponent),
  },
  // Routes Admin
  {
    canActivate: [AuthGuard, RoleGuard],
    canActivateChild: [AuthGuard, RoleGuard],
    component: LayoutComponent,
    path: 'admin',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/admin/list-diagnostic/list-diagnostic.component').then(
            (m) => m.ListDiagnosticComponent,
          ),
      },
      {
        path: 'information/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/information/information.component').then(
            (m) => m.InformationComponent,
          ),
      },
      {
        path: 'questionnaire/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/questionnaire/questionnaire.component').then(
            (m) => m.QuestionnaireComponent,
          ),
      },
      {
        path: 'result/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/result/result.component').then((m) => m.ResultComponent),
      },
    ],
  },
  // Routes client
  {
    canActivate: [AuthGuard, RoleGuard],
    canActivateChild: [AuthGuard, RoleGuard],
    component: LayoutClientComponent,
    path: 'apps',
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/client/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'setting',
        loadComponent: () =>
          import('./pages/client/settings/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: 'users',
        loadChildren: () => import('./pages/client/users/users.routes'),
      },
      {
        path: 'history',
        loadComponent: () =>
          import('./pages/client/evaluation-history/evaluation-history.component').then(
            (m) => m.EvaluationHistoryComponent,
          ),
      },
      {
        path: 'type',
        loadComponent: () =>
          import('./pages/landing/type-diagnostic/type-diagnostic.component').then(
            (m) => m.TypeDiagnosticComponent,
          ),
      },
      {
        path: 'information/:diagnosticType/:questionnaire/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/information/information.component').then(
            (m) => m.InformationComponent,
          ),
      },
      {
        path: 'questionnaire/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/questionnaire/questionnaire.component').then(
            (m) => m.QuestionnaireComponent,
          ),
      },
      {
        path: 'questionnaire/:diagnostic/:typeLabel/edit',
        loadComponent: () =>
          import('./pages/landing/questionnaire/questionnaire.component').then(
            (m) => m.QuestionnaireComponent,
          ),
      },
      {
        path: 'result/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/result/result.component').then((m) => m.ResultComponent),
      },
    ],
  },
  // Routes User Update
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/landing/bienvenu/bienvenu.component').then((m) => m.BienvenuComponent),
      },
      {
        path: 'preamble/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/bienvenu/bienvenu.component').then((m) => m.BienvenuComponent),
      },
      {
        path: 'type',
        loadComponent: () =>
          import('./pages/landing/type-diagnostic/type-diagnostic.component').then(
            (m) => m.TypeDiagnosticComponent,
          ),
      },
      {
        path: 'information/:diagnosticType/:questionnaire/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/information/information.component').then(
            (m) => m.InformationComponent,
          ),
      },
      {
        path: 'questionnaire/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/questionnaire/questionnaire.component').then(
            (m) => m.QuestionnaireComponent,
          ),
      },
      {
        path: 'questionnaire/:diagnostic/:typeLabel/edit',
        loadComponent: () =>
          import('./pages/landing/questionnaire/questionnaire.component').then(
            (m) => m.QuestionnaireComponent,
          ),
      },
      {
        path: 'result/:diagnostic/:typeLabel',
        loadComponent: () =>
          import('./pages/landing/result/result.component').then((m) => m.ResultComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
